export class TextUtils {
  static capitalizeWords(str: string): string {
    if (!str) return str;
    return str
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}
